import React, { useState, useEffect } from "react";
import { Pie } from "react-chartjs-2";
import Chart from "chart.js/auto";

const Encuesta9DeJulio = ({ onClose }) => {
  const [opciones, setOpciones] = useState([
    { opcion: "Si", valor: 0 },
    { opcion: "No", valor: 0 }
  ]);
  const [seleccion, setSeleccion] = useState("");
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");
  const [totalVotos, setTotalVotos] = useState(0);
  const [mensajeExito, setMensajeExito] = useState("");

  const URL_API =
    "https://us-central1-inprojuy-f1173.cloudfunctions.net/app/api/encuestas/9dejulio";

  const fetchResultados = async () => {
    try {
      const res = await fetch(URL_API);
      if (!res.ok) throw new Error("Error al obtener resultados");
      const data = await res.json();
      setOpciones(data.opciones);
      setTotalVotos(data.totalVotos);
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchResultados();
  }, []);

  const enviarVoto = async () => {
    if (!seleccion) {
      setError("Debe seleccionar una opción.");
      return;
    }
    setCargando(true);
    setError("");
    setMensajeExito("");

    try {
      const res = await fetch(
        "https://us-central1-inprojuy-f1173.cloudfunctions.net/app/api/encuestas",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            tema: "9dejulio",
            opciones: [
              { opcion: seleccion, valor: 1 },
              { opcion: seleccion === "Si" ? "No" : "Si", valor: 0 }
            ]
          })
        }
      );

      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.message || "Error al enviar voto");
      }

      await fetchResultados();
      setMensajeExito("✅ Su voto fue registrado correctamente.");

      // Esperar un poco y cerrar
      setTimeout(() => {
        if (onClose) {
          onClose();
        }
      }, 2000);

    } catch (err) {
      setError(err.message);
    } finally {
      setCargando(false);
    }
  };

  const dataChart = {
    labels: opciones.map((o) => o.opcion),
    datasets: [
      {
        data: opciones.map((o) => o.valor),
        backgroundColor: ["#36A2EB", "#FF6384"]
      }
    ]
  };

  return (
    <div
      style={{
        width: "100%",
        margin: "0 auto",
        background: "#fff",
        borderRadius: "8px",
        padding: "0.2rem",
        boxSizing: "border-box"
      }}
    >
      {/* Imagen */}
      <div style={{ textAlign: "center", marginBottom: "1rem" }}>
        <img
          src="/img/9dejulio.png"
          alt=""
          style={{
            width: "50%",
            maxHeight: "120px",
            objectFit: "cover",
            borderRadius: "4px"
          }}
        />
      </div>

      {/* Título */}
      <h3 style={{ textAlign: "center", marginBottom: "1rem" }}>
        ¿Ud desea que haya sorteos de Tómbola el día 9 de julio?
      </h3>

      {/* Error */}
      {error && (
        <div style={{ color: "red", textAlign: "center", marginBottom: "0.5rem" }}>
          {error}
        </div>
      )}

      {/* Éxito */}
      {mensajeExito && (
        <div style={{ color: "green", textAlign: "center", marginBottom: "0.5rem" }}>
          {mensajeExito}
        </div>
      )}

      {/* Botones */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "0.5rem",
          marginBottom: "1rem",
          flexWrap: "wrap"
        }}
      >
        {["Si", "No"].map((opt) => (
          <button
            key={opt}
            onClick={() => setSeleccion(opt)}
            style={{
              padding: "0.5rem 1.2rem",
              backgroundColor: seleccion === opt ? "#007BFF" : "#ccc",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              minWidth: "80px"
            }}
          >
            {opt}
          </button>
        ))}
      </div>

      {/* Botón enviar */}
      <div style={{ textAlign: "center" }}>
        <button
          onClick={enviarVoto}
          disabled={cargando}
          style={{
            padding: "0.6rem 1.2rem",
            fontSize: "1rem",
            backgroundColor: "#28a745",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          }}
        >
          {cargando ? "Enviando..." : "Enviar Voto"}
        </button>
      </div>

      {/* Gráfico */}
      <div
        style={{
          marginTop: "1.5rem",
          width: "100%",
          height: "25%",
          position: "relative"
        }}
      >
        <Pie
          data={dataChart}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: "bottom"
              }
            }
          }}
        />
      </div>

      <div
        style={{
          textAlign: "center",
          marginTop: "0.5rem",
          fontSize: "0.9rem"
        }}
      >
        Total de votos: {totalVotos}
      </div>
    </div>
  );
};

export default Encuesta9DeJulio;
